import { createFileRoute } from '@tanstack/react-router'
import { ProductsManager } from '_/features/finance/ui/components/products-manager'
import { FinanceRepositoriesProvider } from '_/features/finance/ui/contexts/finance-repositories-provider'

const SettingsProducts = () => {
	return (
		<FinanceRepositoriesProvider>
			<ProductsManager />
		</FinanceRepositoriesProvider>
	)
}

export const Route = createFileRoute('/_authenticated/settings/products')({
	staticData: { title: 'settings_title' },
	component: SettingsProducts,
})
